module.exports = __webpack_public_path__ + "img/ruoyi0.cc0b6996.png";